import React from "react";
import { Link } from "react-router-dom";
import { profile } from "../data/profile";

function openAssistant() {
  window.dispatchEvent(new CustomEvent("open-voice-assistant"));
}

function Home() {
  return (
    <section className="site-hero" aria-label="Introduction">
      <div
        className="site-hero-atmosphere"
        aria-hidden="true"
        style={{ backgroundImage: `url(${profile.portrait})` }}
      />
      <div className="site-hero-grid" aria-hidden="true" />
      <div className="site-hero-inner">
        <p className="site-hero-brand animate-hero-in">{profile.name}</p>
        <h1 className="animate-hero-in animate-hero-in--delay-1">{profile.headline}</h1>
        <p className="site-hero-lead animate-hero-in animate-hero-in--delay-2">
          {profile.tagline}
        </p>
        <div className="site-hero-cta animate-hero-in animate-hero-in--delay-3">
          <Link className="btn btn-hero-primary" to="/blogs">
            View my blog
          </Link>
          <button type="button" className="btn btn-hero-secondary" onClick={openAssistant}>
            Talk to my assistant
          </button>
        </div>
      </div>
    </section>
  );
}

export default Home;
